// extracted by mini-css-extract-plugin
export var pill = "Pill-module--pill--7edf1";
export var pillLarge = "Pill-module--pillLarge--a504f";
export var pillSmall = "Pill-module--pillSmall--1514f";